import React from 'react';
import EmailActionHandler from './EmailActionHandler';

const PasswordReset = () => {
  return <EmailActionHandler />;
};

export default PasswordReset; 